import { s } from '@/theme/tokens';
import { SearchFilterField } from '@/ui/composites/filters/SearchFilterField';
import { Box } from '@/ui/primitives';
import type { ReactElement, RefObject } from 'react';

type MetricsToolbarSearchControlProps = {
  toolbarExpandedSearchWidth: number;
  toolbarControlSize: number;
  toolbarSearchWidthPx: string;
  searchValue: string;
  searchAriaLabel: string;
  setSearchValue: (value: string) => void;
  searchInputRef: RefObject<HTMLInputElement | null>;
  handleSearchBlur: () => void;
  handleSearchKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

export const MetricsToolbarSearchControl = ({
  toolbarExpandedSearchWidth,
  toolbarControlSize,
  toolbarSearchWidthPx,
  searchValue,
  searchAriaLabel,
  setSearchValue,
  searchInputRef,
  handleSearchBlur,
  handleSearchKeyDown,
}: MetricsToolbarSearchControlProps): ReactElement => {
  const toolbarFieldBackgroundColor = 'background.default';

  return (
    <Box
      sx={{
        width: toolbarExpandedSearchWidth,
        height: toolbarControlSize,
        minHeight: toolbarControlSize,
        minWidth: toolbarExpandedSearchWidth,
        ml: s('lg'),
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <SearchFilterField
        value={searchValue}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        inputAriaLabel={searchAriaLabel}
        inputBackgroundColor={toolbarFieldBackgroundColor}
        controlHeight={32}
        compact
        leadingSearchAdornment={false}
        trailingSearchAdornment
        filledClearIcon={false}
        sx={{
          width: toolbarSearchWidthPx,
          minWidth: toolbarSearchWidthPx,
          maxWidth: toolbarSearchWidthPx,
          '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
            height: `${toolbarControlSize}px !important`,
          },
          '& .MuiInputBase-input, & .MuiOutlinedInput-input': {
            height: `${toolbarControlSize}px !important`,
            paddingLeft: `${s('sm')} !important`,
            paddingInlineStart: `${s('sm')} !important`,
          },
        }}
        slotProps={{
          htmlInput: {
            ref: (instance: HTMLInputElement | null) => {
              searchInputRef.current = instance;
            },
            onBlur: handleSearchBlur,
            onKeyDown: handleSearchKeyDown,
          },
        }}
      />
    </Box>
  );
};
